import React from 'react';
import { IRadioOption } from './interfaces';
import { FormControlLabel, Radio } from '@mui/material';

export const RadioOption: React.FC<IRadioOption> = ({
  label,
  value,
  sx,
}): JSX.Element => {
  return (
    <FormControlLabel
      value={value}
      control={<Radio size="small" />}
      label={label}
      sx={{
        '.MuiFormControlLabel-label': {
          fontSize: '.9rem',
        },
        ...sx,
      }}
    />
  );
};
